import React from 'react';
import { createDashboardModel } from 'models/dashboard';
import ManageDashboard from 'components/ManageDashboard';

export default function AdminCreateDashboard() {
    const dashboard = createDashboardModel();
    return (
        <div data-testid="route-dashboards-create">
            <ManageDashboard dashboard={dashboard} action={'create'} />
        </div>
    );
}
